// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-details-page-wrapper .text-contailer *{font-family:\"Roboto\",\"PP Right Grotesk\",\"Noto Sans TC\",sans-serif!important}.freshness[x-placement^=bottom]{background:var(--primary-400)!important;color:#fff;padding:.1rem .18rem;text-align:left!important;word-break:break-word!important}.freshness .popper__arrow,.freshness .popper__arrow:after{border-bottom-color:var(--primary-400)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
